export default __webpack_public_path__ + "static/media/logo-with-brain.3d14d693.png";